// if param is 'all', use that. otherwise split string and turn into array of numbers
import {ALL_ACCOUNTING_BASES, SelectedAccountingBases} from '../api/fit-api/models/accounting-basis';

export const selectedAccountingBasesStringParser = (accountingBases: string): SelectedAccountingBases | undefined =>
{
	try {
		return accountingBases === ALL_ACCOUNTING_BASES ? ALL_ACCOUNTING_BASES : accountingBases.split(',').map(Number);
	} catch {
		return undefined;
	}
}
